import React, { useEffect, useState, useRef } from 'react';
import Dropzone, { useDropzone } from "react-dropzone";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { configAxios } from '../../../../utils/ConfigAxios';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Select from "react-select";
import {
    Grid,
    Paper,
    Box,
    Button,
    Typography,
    Tabs,
    Tab,
    Badge,
    Popover,
    IconButton,
    TextField,
    TextareaAutosize,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Alert

} from "@mui/material";
import { Close } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { styled } from "@mui/material/styles";
import { useNavigate } from 'react-router';
import { useDispatch } from "react-redux";
import { CustomizedSnackbar } from '../../../../shared';
import { axiosFetch } from '../../../../utils/AxiosFetch';
import { SnackbarActions } from '../../../../redux/actions/snackbar.actions';
import { useCallback } from 'react';
// import LoadingButton from '@mui/lab/LoadingButton';
// import SaveIcon from '@mui/icons-material/Save';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    // ValidatorForm.addValidationRule("")
    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

// const maxSize = 26214400;
const FileUpload = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [openFileUpload, setOpenFileUpload] = useState(false);
    const [isValidUrl, setIsValidUrl] = useState(false);
    const [filePhysicalName, setFilePhysicalName] = useState(null);
    const [fileActualName, setFileActualName] = useState(null);
    const [fileUploadedDate, setFileUploadedDate] = useState(null);
    const [url, setURL] = useState("");
    const [myFiles, setMyFiles] = useState([]);
    const [attachmentId, setAttachementId] = useState("");
    const [loadedFiles, setLoadedFiles] = useState([]);
    const [urlList, setUrlList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [selectedType, setSelectedType] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isValidFileType, setIsValidFileType] = useState(false);


    // const allowedTypes = ["image/*", ".pdf", ".xls", ".xlsx", ".txt", ".csv", ".doc", ".docx", ".ppt", ".pptx"];

    // const renderAcceptedFileTypes = () => {
    //     let typesStr = "";
    //     if (allowedTypes) {
    //         allowedTypes.forEach((type /*, index*/) => {
    //             typesStr += `${type}, `;
    //         });
    //     }
    //     else {
    //         console.log("not accepted")
    //     }

    //     return typesStr;
    // };

    function is_url(str) {
        var regexp;
        if (str.includes('localhost')) {
            regexp = /^https?:\/\/\w+(\.\w+)*(:[0-9]+)?(\/.*)?$/;
        }
        else {
            regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
        }
        if (regexp.test(str)) {
            return true;
        }
        else {
            return false;
        }
    }
    const uploadFilePopup = () => {
        setOpenFileUpload(!openFileUpload);
        setMyFiles([]);
        setURL("");
        setIsValidUrl(false);
        setLoadedFiles([]);
        setSelectedType(null);
        setIsValidFileType(false);
        setIsLoading(false);
    };

    const loadFileType = () => {
        axiosFetch({
            method: "get",
            url: "/Lookup/attachmenttypes"
        })
            .then((res) => {
                if (res.status === 200) {
                    setTypeList(res.data);
                }
                else if (res.status === 401) {
                    navigate("/");
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
            })
            .catch(err => {
                console.error(err);
            })
    }


    useEffect(() => {
        loadFileType();
    }, []);


    const handleChangeURL = (e) => {


        if (e.target.value === "") {
            setIsValidUrl(false);
        }
        else {
            setIsValidUrl(!is_url(e.target.value));
        }
        setURL(e.target.value);
    };


    const uploadFile = (file) => {

        configAxios
            .post("/Uploads/file", file)
            .then((res) => {
                setIsLoading(false);
                if (res.status === 200) {

                    setIsLoading(true);

                    setLoadedFiles([...loadedFiles, ...res.data]);
                }
                else if (res.status === 401) {
                    navigate("/");
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
            })
            .catch(err => {
                console.error(err);
            })
    };

    const onDrop = useCallback((acceptedFiles) => {
        const fileSize = (acceptedFiles[0].size) / 1048576
        const roundOff = Math.floor(fileSize)
        setIsValidFileType(false);
        const validTypes = ['jpeg', 'txt', 'jpg', 'png', 'gif', "pdf", "doc", "docx", "xls", "xlsx", "csv", "tsv", "ppt", "pptx", "pages", "odt", "rtf"];
        if (roundOff < 31) {
            if (acceptedFiles && acceptedFiles[0]) {
                const formData = new FormData();
                acceptedFiles.map((file, index) => {
                    if (validTypes.indexOf(file.name.split('.').pop()) !== -1) {

                        formData.append("file", acceptedFiles[index], acceptedFiles[index].name);
                        uploadFile(formData);
                        setIsValidFileType(false);
                        setMyFiles([...myFiles, ...acceptedFiles]);
                    }
                    else {
                        setIsValidFileType(true);
                    }


                })

            }
        }
        else {
            dispatch(SnackbarActions(true, "warning", "File Size limit upto 30mb"))
        }

    }, [myFiles]);


    const removeFile = file => () => {
        const newFiles = [...myFiles]
        newFiles.splice(newFiles.indexOf(file), 1)
        setMyFiles(newFiles)
        if (newFiles.length === 0 && urlList.length === 0) {
            setIsLoading(false);
        }
    }

    const removeAll = () => {
        setMyFiles([]);
        setLoadedFiles([]);
        setIsValidFileType(false);
        if(urlList.length === 0){
            setIsLoading(false);
        }
    };

    const removeAllURL = () => {
        setUrlList([]);
        if(myFiles.length === 0){
            setIsLoading(false)
        }
    }

    const files = myFiles.map(file => (
        <li key={file.path} style={{ listStyleType: "decimal", height: "45px" }}>
            {file.path}
            <Button className='theme-btn cancel-btn' onClick={removeFile(file)}>Remove File</Button>
        </li>
    ))


    const uploadOKRAttachments = (e) => {

        let link;

        if (url !== "" && (url.indexOf("http://") == 0 || url.indexOf("https://") == 0)) {
            link = url;
        }
        else if (url !== "") {
            link = "http://" + url;
            setURL(link);
        }
        var myArr = [];
        var obj = null;
        if (loadedFiles.length !== 0) {
            loadedFiles.map((item, index) => {
                obj = {
                    "OkrId": parseInt(props.okrId),
                    "TypeId": selectedType !== null ? parseInt(selectedType.value) : null,
                    "PhysicalName": loadedFiles[index].physicalFileName,
                    "ActualFileName": loadedFiles[index].actualFileName,
                    "UploadedDate": loadedFiles[index].uploadedDate,
                    "url": null
                }
                myArr.push(obj);
            });

        }
        if (urlList.length !== 0) {

            let urlString;
            urlList.map((item, index) => {

                if (urlList[index].url.indexOf("http://") == 0 || urlList[index].url.indexOf("https://") == 0) {

                    urlString = urlList[index].url;
                }
                else {

                    urlString = "http://" + urlList[index].url;
                }

                urlString =
                    obj = {
                        "OkrId": parseInt(props.okrId),
                        "TypeId": selectedType !== null ? parseInt(selectedType.value) : null,
                        "PhysicalName": null,
                        "ActualFileName": null,
                        "UploadedDate": null,
                        "url": urlString
                    }
                myArr.push(obj);
            });
        }
        if (urlList.length === 0 && url !== "") {
            obj = {
                "OkrId": parseInt(props.okrId),
                "TypeId": selectedType !== null ? parseInt(selectedType.value) : null,
                "PhysicalName": null,
                "ActualFileName": null,
                "UploadedDate": null,
                "url": link
            }
            myArr.push(obj);
        }



        e.preventDefault();


        var flag = true;
        if (url !== "" && urlList.length === 0) {
            if (is_url(url)) {
                setIsValidUrl(false);
                flag = true;
            }
            else {
                setIsValidUrl(true);
                flag = false;
            }
        }
        else if (myFiles.length !== 0) {
            flag = true;
        }
        else if (url === "" && urlList.length === 0) {
            dispatch(SnackbarActions(true, "warning", "Please Enter Something!"));
            return false;
        }
        if (flag) {

            axiosFetch({
                url: "/OKRs/okr/Attachment",
                method: "POST",
                requestConfig: { "Attachments": myArr }

            })
                .then((res) => {
                    setLoadedFiles([]);
                    if (res.status === 200) {
                        setAttachementId(res.data);
                        dispatch(SnackbarActions(true, "success", "Uploaded Successfully!"));
                        setOpenFileUpload(false);
                        props.loadOKR();
                    }
                    else if (res.status === 400) {
                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                        setOpenFileUpload(false);
                    }
                    else if (res.status === 401) {
                        navigate("/");
                    }
                })
        }
        else {
            setIsValidUrl(true);
        }


    }

    const clearAll = () => {
        setMyFiles([]);
        setURL("");
        setUrlList([]);
        setSelectedType(null);
        setIsValidUrl(false);
        setIsValidFileType(false);
        setIsLoading(false);
    };

    const addUrl = () => {

        var link;
        if (url !== "" && (url.indexOf("http://") == 0 || url.indexOf("https://") == 0)) {
            link = url;
            setIsLoading(true)
        }
        else if (url !== "") {
            link = "http://" + url;
            setURL(link);
            setIsLoading(true)
        }
        if (is_url(link) && link !== "") {
            var obj = {
                url: link
            }
            setUrlList([...urlList, obj]);
            setURL("");
        }
        // when it's invalid
        else if (!is_url(url)) {
            setIsValidUrl(true);
            return false;
        }
        else {
            dispatch(SnackbarActions(true, "warning", "Please Enter One URL Atleast!"));
            return false;
        }

    };

    const removeUrl = url => () => {
        const newUrlList = [...urlList];
        newUrlList.splice(newUrlList.indexOf(url), 1);
        setUrlList(newUrlList);
        if(myFiles.length === 0){
            setIsLoading(false)
        }
    };

    const urls = urlList.map(url => (
        <li style={{ listStyleType: "decimal", height: "45px" }}>
            {url.url}
            <Button className='theme-btn cancel-btn' onClick={removeUrl(url)}> Remove URL</Button>
        </li>
    ))


    return (
        <div className='mb-2'>
            <Button className='theme-btn' sx={{ float: "none" }} onClick={uploadFilePopup}>Upload File</Button>
            <BootstrapDialog
                aria-labelledby="customized-dialog-title"
                open={openFileUpload}
                fullWidth="sm"
                maxWidth="sm"
                onClose={uploadFilePopup}
            >
                <ValidatorForm >
                    <BootstrapDialogTitle className="modal-heading">
                        Upload OKR Attachments
                    </BootstrapDialogTitle>
                    <DialogContent dividers>
                        <Box
                            alignItems="center"
                            display="flex"
                            justifyContent="center"
                            component="form"
                            autoComplete="off"
                        >
                            <Grid container xs={12} item spacing={2} className="grid-margins">
                                <Grid item xs={12} className="grid-margins">
                                    <Alert severity='error'>Accepted file types : <em>jpeg, jpg, png, gif, pdf, doc, docx, xls, xlsx, csv, ppt, pptx</em></Alert>
                                </Grid>
                                <Grid item xs={12} className="grid-margins">
                                    <Select
                                        placeholder="Select File Type"
                                        value={selectedType}
                                        options={typeList}
                                        onChange={setSelectedType}
                                    />
                                </Grid>
                                <Grid item xs={12} className="grid-margins">
                                    <Dropzone
                                        disableClick={true}
                                        onDrop={onDrop}
                                        className="dropzone"
                                        activeClassName="active-dropzone"

                                    // minSize={0}
                                    // maxSize={maxSize}
                                    >
                                        {({ getRootProps, getInputProps }) => {
                                            return (
                                                <section>
                                                    <div
                                                        {...getRootProps()}
                                                        style={{
                                                            cursor: "pointer",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        <input
                                                            {...getInputProps()}
                                                        />
                                                        <p>
                                                            <UploadFileIcon /> Click here to Choose File
                                                        </p>
                                                    </div>
                                                    <ol style={{ paddingLeft: "10px" }}>{files}</ol>
                                                    {isValidFileType && "Upload only above mentioned file types"}
                                                    {files.length > 1 && <Button className='theme-btn cancel-btn' onClick={removeAll}>Remove All</Button>}
                                                </section>
                                            )
                                        }}
                                    </Dropzone>

                                </Grid>
                                <Grid item xs={12} className="grid-margins">
                                    <center>-- (or) --</center>
                                </Grid>
                                <Grid item xs={12} className="grid-margins">
                                    <TextValidator
                                        variant="outlined"
                                        label="Enter File Url"
                                        fullWidth
                                        value={url}
                                        onChange={handleChangeURL}
                                    />
                                    <p className='error-message'>{isValidUrl ? "Please Enter Valid Url" : ""}</p>
                                </Grid>
                                <Grid item xs={12} className="grid-margins">
                                    <ol style={{ paddingLeft: "10px" }}>{urls}</ol>
                                </Grid>
                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                    {urlList.length > 1 && <Button className='theme-btn cancel-btn' onClick={removeAllURL}>Remove All</Button>}
                                    <Button className='theme-btn' sx={{ marginLeft: "10px" }} onClick={addUrl}>ADD MULTIPLE URL</Button>
                                </Grid>
                                {/* <Grid item xs={12}>
                                                                    
                                </Grid> */}
                            </Grid>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={clearAll} className="theme-btn cancel-btn">Clear</Button>
                        {isLoading ? <Button variant="contained" onClick={uploadOKRAttachments} className="theme-btn">Upload File</Button> : ''}
                    </DialogActions>
                </ValidatorForm>

            </BootstrapDialog>
        </div >
    )
}

export default FileUpload;